import styled from '@emotion/styled';
import { Link } from '@router/Link';
import { useAtomValue } from 'jotai';

import { tierCalculatedDateAtom } from '../../atoms/tierAtoms';

function TierCalcFilter() {
    const calculatedDate = useAtomValue(tierCalculatedDateAtom);
    return (
        <Wrapper>
            <Link activityName='TierCalculatedDateBottomSheet'
                activityParams={{}}>
                <Button>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 11.5L6 5" stroke="#504A46" strokeWidth="1.8" strokeLinecap="square"/>
                        <path d="M18 11.5L18 5" stroke="#504A46" strokeWidth="1.8" strokeLinecap="square"/>
                        <path d="M12 12.5L12 19" stroke="#504A46" strokeWidth="1.8" strokeLinecap="square"/>
                        <path d="M6 19L6 17" stroke="#504A46" strokeWidth="1.8" strokeLinecap="square"/>
                        <path d="M18 19L18 17" stroke="#504A46" strokeWidth="1.8" strokeLinecap="square"/>
                        <path d="M12 5L12 7" stroke="#504A46" strokeWidth="1.8" strokeLinecap="square"/>
                        <mask id="path-7-inside-1_1331_4399" fill="white">
                            <rect x="4" y="12" width="4" height="5" rx="1"/>
                        </mask>
                        <rect x="4" y="12" width="4" height="5" rx="1" stroke="#504A46" strokeWidth="2.6" mask="url(#path-7-inside-1_1331_4399)"/>
                        <mask id="path-8-inside-2_1331_4399" fill="white">
                            <rect x="16" y="12" width="4" height="5" rx="1"/>
                        </mask>
                        <rect x="16" y="12" width="4" height="5" rx="1" stroke="#504A46" strokeWidth="2.6" mask="url(#path-8-inside-2_1331_4399)"/>
                        <mask id="path-9-inside-3_1331_4399" fill="white">
                            <rect x="10" y="7" width="4" height="5" rx="1"/>
                        </mask>
                        <rect x="10" y="7" width="4" height="5" rx="1" stroke="#504A46" strokeWidth="2.6" mask="url(#path-9-inside-3_1331_4399)"/>
                    </svg>
                    {calculatedDate && (
                        <Dot/>
                    )}
                </Button>
            </Link>
        </Wrapper>
    );
}
const Wrapper = styled.div`
    padding: 0 16px;
    display: flex;
    justify-content: flex-end;
    width: 100%;
`;

const Button = styled.button`
    background-color: var(--color-gray2);
    padding: 8px 16px;
    border-radius: 12px;
    position: relative;
`;

const Dot = styled.div`
    width: 6px;
    height: 6px;
    background-color: var(--color-red);
    border-radius: 3px;
    position: absolute;
    right: 0;
    top: 0;
`;

export default TierCalcFilter;
